// extracted by mini-css-extract-plugin
export default {"dlmText":"groups_dlmText__RO0LM","container":"groups_container__eBw-x","loader":"groups_loader__sWuC5"};